module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-hairmake-men-4cc8cf5229342b04ee539fbff048b47b.jpg";